/* Progressive enhancements only. Shopify owns products, inventory and checkout. */
(() => {
  const strings = JSON.parse(
    document.getElementById("veril-strings")?.textContent || "{}",
  );
  const root = () => window.Shopify?.routes?.root || "/";
  let cartBusy = false;
  let cartUncertain = false;
  let drawerTrigger;
  const drawer = () => document.querySelector("[data-cart-dialog]");
  let drawerLoading = false;
  function openDrawer(trigger) {
    const dialog = drawer();
    if (!dialog?.showModal) return false;
    if (!dialog.open) {
      drawerTrigger = trigger;
      dialog.showModal();
      dialog.querySelector("[data-dialog-close]").focus();
    }
    return true;
  }
  function drawerFailure() {
    const dialog = drawer();
    dialog.querySelector("[data-drawer-error]").hidden = false;
    dialog
      .querySelectorAll(
        "[data-drawer-checkout], [data-drawer-remove], [data-pack-form] button",
      )
      .forEach((button) => (button.disabled = true));
  }
  async function refreshDrawer() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    const dialog = drawer();
    const activeId = dialog.contains(document.activeElement)
      ? document.activeElement.id
      : "";
    try {
      const response = await fetch(root() + "cart?section_id=cart-drawer", {
        credentials: "same-origin",
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(strings.error);
      const html = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
      const next = html.querySelector("[data-cart-dialog]");
      if (!next) throw new Error(strings.error);
      dialog.replaceChildren(...next.childNodes);
      if (dialog.open && activeId)
        (
          document.getElementById(activeId) ||
          dialog.querySelector("[data-dialog-close]")
        ).focus();
    } finally {
      clearTimeout(timeout);
    }
  }
  async function loadDrawer(trigger) {
    if (drawerLoading || cartBusy || !openDrawer(trigger)) return;
    drawerLoading = true;
    drawer().setAttribute("aria-busy", "true");
    drawer().querySelector("[data-drawer-status]").textContent =
      strings.drawerLoading;
    drawer()
      .querySelectorAll(
        "[data-drawer-checkout], [data-drawer-remove], [data-pack-form] button",
      )
      .forEach((button) => (button.disabled = true));
    try {
      const cart = await request("cart.js");
      updateCount(cart);
      await refreshDrawer();
      if (cartUncertain && document.querySelector("[data-cart-section]"))
        await refreshCart();
      cartUncertain = false;
    } catch {
      drawerFailure();
    } finally {
      drawerLoading = false;
      drawer().removeAttribute("aria-busy");
    }
  }
  async function showConfirmation(form, data, cart, trigger) {
    if (!openDrawer(trigger || form.querySelector("[type=submit]"))) return;
    document.querySelector("[data-feedback]").hidden = true;
    try {
      await refreshDrawer();
      drawer().querySelector("[data-drawer-status]").textContent =
        strings.drawerAdded;
      // Preserve confirmation metadata without visually repeating the cart lines.
      drawer().querySelector("[data-added-title]").textContent =
        form.dataset.productTitle;
      drawer().querySelector("[data-added-quantity]").textContent =
        data.get("quantity") || "1";
      const source = form
        .closest("[data-product-section]")
        ?.querySelector(".gallery-item img");
      const image = drawer().querySelector("[data-added-image]");
      const src =
        form.dataset.productImage || source?.currentSrc || source?.src;
      if (src) {
        image.src = src;
        image.hidden = false;
      }
    } catch {
      drawerFailure();
    }
  }
  document.addEventListener(
    "close",
    (event) => {
      if (event.target !== drawer()) return;
      const target = drawerTrigger?.isConnected
        ? drawerTrigger
        : document.querySelector("[data-cart-open]");
      target?.focus();
    },
    true,
  );
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Tab" || !drawer()?.open) return;
    const controls = [
      ...drawer().querySelectorAll(
        "a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled)",
      ),
    ].filter((node) => node.getClientRects().length);
    const first = controls[0],
      last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  const message = (text, error = false) => {
    const box = document.querySelector("[data-feedback]");
    if (!box) return;
    box.querySelector("[data-feedback-text]").textContent = text;
    box.setAttribute("role", error ? "alert" : "status");
    box.hidden = false;
  };
  const request = async (path, body) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root() + path, {
        method: body ? "POST" : "GET",
        credentials: "same-origin",
        signal: controller.signal,
        headers:
          body instanceof FormData
            ? { Accept: "application/json" }
            : {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
        ...(body
          ? { body: body instanceof FormData ? body : JSON.stringify(body) }
          : {}),
      }).catch(() => {
        throw new Error(strings.error);
      });
      const data = await response.json().catch(() => {
        throw new Error(strings.error);
      });
      if (!response.ok || data.status >= 400)
        throw new Error(data.description || data.message || strings.error);
      return data;
    } finally {
      clearTimeout(timeout);
    }
  };
  const updateCount = (cart) =>
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = `(${cart.item_count})`;
    });
  const refreshCart = async (focusId) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    let html;
    try {
      const response = await fetch(
        root() +
          "cart?section_id=" +
          encodeURIComponent(
            document.querySelector("[data-cart-section]")?.dataset.sectionId ||
              "main-cart",
          ),
        { credentials: "same-origin", signal: controller.signal },
      );
      if (!response.ok) throw new Error(strings.error);
      html = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      );
    } finally {
      clearTimeout(timeout);
    }
    const next = html.querySelector("[data-cart-section]");
    if (!next) throw new Error(strings.error);
    document.querySelector("[data-cart-section]")?.replaceWith(next);
    setup(next);
    cartUncertain = false;
    const status = next.querySelector("[data-cart-status]");
    if (status) status.textContent = strings.cartChanged;
    (document.getElementById(focusId) || status)?.focus();
  };
  const lockCart = (value) => {
    cartBusy = value;
    document
      .querySelector("[data-cart-section]")
      ?.setAttribute("aria-busy", String(value));
    const progress = document.querySelector("[data-cart-progress]");
    if (progress) progress.hidden = !value;
    document
      .querySelectorAll(
        "#CartForm button, [data-cart-quantity], [data-cart-dialog] button:not([data-dialog-close])",
      )
      .forEach((node) => {
        if (value) {
          node.dataset.wasDisabled = String(node.disabled);
          node.disabled = true;
        } else if ("wasDisabled" in node.dataset) {
          node.disabled = node.dataset.wasDisabled === "true";
          delete node.dataset.wasDisabled;
        }
      });
  };
  async function changeLine(key, quantity, focusId, inDrawer = false) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    lockCart(true);
    try {
      const cart = await request("cart/change.js", { id: key, quantity });
      updateCount(cart);
      if (inDrawer) {
        await refreshDrawer();
        cartUncertain = false;
        if (document.querySelector("[data-cart-section]")) await refreshCart();
        drawer().querySelector("[data-dialog-close]").focus();
      } else await refreshCart(focusId);
    } catch (error) {
      // A lost response can follow a successful mutation. Never retry the write.
      try {
        updateCount(await request("cart.js"));
        if (inDrawer) {
          await refreshDrawer();
          cartUncertain = false;
          if (document.querySelector("[data-cart-section]"))
            await refreshCart();
          drawer().querySelector("[data-dialog-close]").focus();
        } else await refreshCart(focusId);
      } catch {
        cartUncertain = true;
      }
      message(
        error.message === "Failed to fetch" ? strings.error : error.message,
        true,
      );
    } finally {
      lockCart(false);
      if (cartUncertain) {
        if (inDrawer) drawerFailure();
        const checkout = document.querySelector("#CartForm [name=checkout]");
        if (checkout) checkout.disabled = true;
        const recovery = document.querySelector("[data-cart-recovery]");
        if (recovery) recovery.hidden = false;
      }
    }
  }
  async function upgradeRitual(button) {
    if (cartBusy || cartUncertain) return;
    const review = button.closest("[data-upgrade-review]");
    const plan = JSON.parse(
      review.querySelector("[data-upgrade-plan]").textContent,
    );
    lockCart(true);
    try {
      const current = await request("cart.js");
      const same =
        current.items.length === plan.expected.length &&
        plan.expected.every((expected) =>
          current.items.some(
            (item) =>
              item.key === expected.key && item.quantity === expected.quantity,
          ),
        );
      if (
        !same ||
        current.items.some(
          (item) => (item.product_id || item.product?.id) === plan.product,
        )
      ) {
        updateCount(current);
        await refreshCart();
        message(strings.upgradeStale, true);
        return;
      }
      const updates = Object.fromEntries(plan.remove.map((key) => [key, 0]));
      updates[String(plan.variant)] = 1;
      // One explicit cart update. Never retry a write after an uncertain response.
      const cart = await request("cart/update.js", { updates });
      if (
        !cart.items.some(
          (item) => item.variant_id === plan.variant && item.quantity === 1,
        ) ||
        cart.items.some((item) => plan.remove.includes(item.key))
      )
        throw new Error(strings.upgradeError);
      updateCount(cart);
      await refreshCart();
      const status = document.querySelector("[data-cart-status]");
      if (status) status.textContent = strings.upgradeDone;
    } catch (error) {
      try {
        updateCount(await request("cart.js"));
        await refreshCart();
      } catch {
        cartUncertain = true;
      }
      message(strings.upgradeError + " " + error.message, true);
    } finally {
      lockCart(false);
      if (cartUncertain) {
        document
          .querySelectorAll("#CartForm [name=checkout], [data-cart-upgrade]")
          .forEach((node) => (node.disabled = true));
        const recovery = document.querySelector("[data-cart-recovery]");
        if (recovery) recovery.hidden = false;
      }
    }
  }
  document.addEventListener("submit", async (event) => {
    if (
      (event.target.id === "CartForm" ||
        event.target.closest("[data-cart-dialog]")) &&
      (cartBusy || drawerLoading || cartUncertain)
    ) {
      event.preventDefault();
      return;
    }
    const form = event.target.closest("[data-product-form], [data-pack-form]");
    if (!form) return;
    event.preventDefault();
    if (
      cartBusy ||
      drawerLoading ||
      form.dataset.busy ||
      event.submitter?.disabled ||
      form.querySelector('[name="add"]')?.disabled
    )
      return;
    form.dataset.busy = "true";
    lockCart(true);
    const buttons = [
      ...form.querySelectorAll('button[type="submit"]'),
      ...document.querySelectorAll(`button[form="${form.id}"]`),
    ];
    const labels = buttons.map((button) => button.innerHTML);
    const errorBox = form.querySelector("[data-form-error]");
    errorBox.hidden = true;
    const data = new FormData(form);
    const trigger = event.submitter;
    buttons.forEach((button) => {
      button.disabled = true;
      button.textContent = strings.adding;
    });
    try {
      await request("cart/add.js", data);
      message(strings.added);
      let cart;
      try {
        cart = await request("cart.js");
        updateCount(cart);
      } catch {
        /* The add succeeded: never retry it. */
      }
      await showConfirmation(form, data, cart, trigger);
      if (document.querySelector("[data-cart-section]")) await refreshCart();
    } catch (error) {
      errorBox.textContent =
        error.message === "Failed to fetch" ? strings.error : error.message;
      errorBox.hidden = false;
      // Unknown network outcome: direct customer to cart, never auto-add again.
      message(strings.error, true);
      if (drawer()?.open) {
        try {
          await refreshDrawer();
        } catch {
          drawerFailure();
        }
        const operationError = drawer().querySelector(
          "[data-drawer-operation-error]",
        );
        operationError.textContent = error.message;
        operationError.hidden = false;
      }
    } finally {
      lockCart(false);
      delete form.dataset.busy;
      buttons.forEach((button, i) => {
        button.disabled = false;
        button.innerHTML = labels[i];
      });
      if (drawer()?.querySelector("[data-drawer-error]:not([hidden])"))
        drawerFailure();
    }
  });
  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-variant-select]")) {
      const url = new URL(location.href);
      url.searchParams.set("variant", event.target.value);
      location.assign(url); // Retains campaign parameters; native Liquid re-renders exact variant price and stock.
    }
    if (event.target.matches("[data-cart-quantity]")) {
      if (event.target.checkValidity())
        changeLine(
          event.target.dataset.key,
          Number(event.target.value),
          event.target.id,
        );
      else event.target.reportValidity();
    }
  });
  document.addEventListener("click", (event) => {
    const cartLink = event.target.closest("[data-cart-open]");
    if (
      cartLink &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey &&
      event.button === 0 &&
      drawer()?.showModal
    ) {
      event.preventDefault();
      loadDrawer(cartLink);
      return;
    }
    const drawerRemove = event.target.closest("[data-drawer-remove]");
    if (drawerRemove) {
      changeLine(drawerRemove.dataset.key, 0, drawerRemove.id, true);
      return;
    }
    const upgrade = event.target.closest("[data-cart-upgrade]");
    if (upgrade) {
      upgradeRitual(upgrade);
      return;
    }
    const cancel = event.target.closest("[data-upgrade-cancel]");
    if (cancel) {
      const review = cancel.closest("details");
      review.open = false;
      review.querySelector("summary").focus();
    }
    if (event.target.closest("[data-dialog-close]")) drawer()?.close();
    if (event.target === drawer()) {
      const rect = drawer().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right)
        drawer().close();
    }
    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.key, 0);
    }
    const dismiss = event.target.closest("[data-dismiss]");
    if (dismiss) {
      dismiss.closest("[data-feedback]").hidden = true;
      document.querySelector(".cart-link")?.focus();
    }
    const menu = document.querySelector(".mobile-menu[open]");
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const menu = document.querySelector(".mobile-menu[open]");
    if (menu) {
      menu.open = false;
      menu.querySelector("summary").focus();
    }
  });
  document.addEventListener("focusin", (event) => {
    const menu = document.querySelector(".mobile-menu[open]");
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  const observers = new Map();
  const galleries = new Map();
  function setupGalleries(scope) {
    scope.querySelectorAll("[data-gallery]").forEach((gallery) => {
      if (galleries.has(gallery)) return;
      const track = gallery.querySelector("[data-gallery-track]");
      const items = [...gallery.querySelectorAll("[data-gallery-item]")];
      const links = [...gallery.querySelectorAll("[data-gallery-select]")];
      const buttons = [...gallery.querySelectorAll("[data-gallery-step]")];
      let current = 0;
      buttons.forEach((button) => (button.hidden = false));
      function update(index) {
        current = index;
        links.forEach((link, i) =>
          i === index
            ? link.setAttribute("aria-current", "true")
            : link.removeAttribute("aria-current"),
        );
        buttons.forEach(
          (button) =>
            (button.disabled =
              Number(button.dataset.galleryStep) < 0
                ? index === 0
                : index === items.length - 1),
        );
        items.forEach((item, i) => {
          if (i !== index)
            item.querySelectorAll("video").forEach((video) => video.pause());
        });
      }
      const go = (index) => {
        index = Math.max(0, Math.min(items.length - 1, index));
        const rtl = document.documentElement.dir === "rtl";
        track.scrollTo({
          left: items[index].offsetWidth * index * (rtl ? -1 : 1),
          behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "instant"
            : "smooth",
        });
      };
      const click = (event) => {
        const link = event.target.closest("[data-gallery-select]");
        const step = event.target.closest("[data-gallery-step]");
        if (link) {
          event.preventDefault();
          go(Number(link.dataset.gallerySelect));
        }
        if (step) go(current + Number(step.dataset.galleryStep));
      };
      gallery.addEventListener("click", click);
      const observer = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) update(items.indexOf(entry.target));
          }),
        { root: track, threshold: 0.6 },
      );
      items.forEach((item) => observer.observe(item));
      update(0);
      galleries.set(gallery, () => {
        observer.disconnect();
        gallery.removeEventListener("click", click);
      });
    });
  }
  const mobile = matchMedia("(max-width:767px)");
  const reserveStickySpace = () => {
    const shown = document.querySelector("[data-sticky-buy]:not([hidden])");
    document.body.style.paddingBottom = mobile.matches && shown ? "90px" : "";
  };
  mobile.addEventListener("change", reserveStickySpace);
  function setup(scope = document) {
    scope
      .querySelectorAll("[data-upgrade-review]")
      .forEach((node) => (node.hidden = false));
    setupGalleries(scope);
    scope.querySelectorAll("[data-product-section]").forEach((section) => {
      if (observers.has(section)) return;
      const sticky = section.querySelector("[data-sticky-buy]");
      const form = section.querySelector("[data-product-form]");
      if (!sticky || !form || !("IntersectionObserver" in window)) return;
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          sticky.hidden =
            entry.isIntersecting || entry.boundingClientRect.bottom > 0; // Appear only after the main buy button has scrolled above the viewport.
          reserveStickySpace();
        },
        { threshold: 0 },
      );
      observer.observe(form.querySelector('[name="add"]') || form);
      observers.set(section, observer);
    });
  }
  setup();
  document.addEventListener("shopify:section:load", (event) =>
    setup(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    observers.forEach((observer, section) => {
      if (event.target.contains(section)) {
        observer.disconnect();
        observers.delete(section);
      }
    });
    galleries.forEach((cleanup, gallery) => {
      if (event.target.contains(gallery)) {
        cleanup();
        galleries.delete(gallery);
      }
    });
    document.body.style.paddingBottom = "";
  });
})();
